import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Redirect } from "react-router-dom";
import _ from 'lodash';
import { sharedLabelsPath } from "../../../reducers/common/localization";
import ActivateEmployeeAccount from './activateEmployeeAccount/ActivateEmployeeAccount.container';
import ActivateApplicantAccount from './activateApplicantAccount/ActivateApplicantAccount.container';
import { ROLES } from '../../../reducers/account/role';

class ActivateUserAccount extends Component {
    componentWillMount() {
        this.props.onGetUserData(this.props.token);
    }  

    render() {
        if (!this.props.token) {
            return <h6 className="incorrect-activation-employee-container">{_.get(this.props.translation, 'activation.incorrect_activation_link_alert')}</h6>;
        }
        if (this.props.loading) {
            return <h6 className="text-center">{_.get(this.props.translation, sharedLabelsPath.fetching_message)}</h6>;
        }
        if (this.props.success) {
            return <Redirect to="/login" />;
        }
        if (!_.isNil(this.props.error)) {
            return this.getTokenIrrelevantMessage();
        }
        switch (ROLES[this.props.role]) {
            case ROLES.SYS_ADMIN:
            case ROLES.EMPLOYEE:
                return (
                    <ActivateEmployeeAccount token={this.props.token} />
                );
            case ROLES.APPLICANT:
                return (
                    <ActivateApplicantAccount token={this.props.token} />
                );   
            default:
                return null;
        }
    }

    getTokenIrrelevantMessage = () => {
        return (
            <div className="irrelevant-employee-activation-link">
                <h5>{_.get(this.props.translation, 'activation.activation_link_irrelevant_message')}</h5>
                <div>
                    <span>{_.get(this.props.translation, 'activation.activation_link_irrelevant_forgot_password_message_start')}</span>
                    <span><a href="/login/restore">{_.get(this.props.translation, 'activation.activation_link_irrelevant_forgot_password_message_link')}</a></span>
                    <span>{_.get(this.props.translation, 'activation.activation_link_irrelevant_forgot_password_message_end')}</span>
                </div>
                <div>
                    <span>{_.get(this.props.translation, 'activation.activation_link_irrelevant_log_in_message_start')}</span>
                    <span><a href="/login">{_.get(this.props.translation, 'activation.activation_link_irrelevant_log_in_message_link')}</a></span>
                    <span>{_.get(this.props.translation, 'activation.activation_link_irrelevant_log_in_message_end')}</span>
                </div>
            </div>
        )
    };
}

ActivateUserAccount.propTypes = {
    loading: PropTypes.bool,
    role: PropTypes.string,
    error: PropTypes.string,
    location: PropTypes.object.isRequired,
    success: PropTypes.bool,
    token: PropTypes.string,
    translation: PropTypes.object.isRequired,
    onGetUserData: PropTypes.func.isRequired
};

export default ActivateUserAccount;



// WEBPACK FOOTER //
// ./src/components/accountManagement/activateUserAccount/ActivateUserAccount.js